import {
  DepositCategory,
  NonDeliveryReason,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

/**
 * フォームの情報
 */
const claimHeadTitleList: any[] = [
  {
    headTitle: "請求ID",
  },
  {
    headTitle: "請求日",
  },
  {
    headTitle: "請求金額",
  },
  {
    headTitle: "請求先名",
  },
  {
    headTitle: "区分",
  },
];

const depositHeadTitleList: any[] = [
  {
    headTitle: "入金ID",
  },
  {
    headTitle: "番号",
  },
  {
    headTitle: "取引日付",
  },
  {
    headTitle: "入金額",
  },
  {
    headTitle: "摘要",
  },
  {
    headTitle: "銀行/支店",
  },
  {
    headTitle: "区分",
  },
];

const fakeTableList: any[] = [
  {
    title: "入金データ",
    keyword: "info1",
    type: "lineTitle",
    lineTitle: "【入金データ】",
  },
  {
    title: "入金ID",
    keyword: "depositId",
    type: "text",
  },
  {
    title: "番号",
    keyword: "number",
    type: "text",
  },
  {
    title: "取引日付",
    keyword: "transactionDate",
    type: "text",
  },
  {
    title: "入金額",
    keyword: "depositAmount",
    type: "text",
  },
  {
    title: "摘要",
    keyword: "summary",
    type: "text",
  },
  {
    title: "銀行/支店",
    keyword: "bank",
    type: "text",
  },
  {
    title: "区分",
    keyword: "kbn",
    type: "selectForm",
    label: "区分",
    selectPropsList: TkGetCodeList(DepositCategory),
    fullWidth: false,
  },
  {
    title: "不着事由",
    keyword: "reason",
    type: "selectForm",
    label: "不着事由",
    selectPropsList: TkGetCodeList(NonDeliveryReason),
    fullWidth: false,
  },
  {
    title: "被共済職員情報",
    keyword: "info",
    type: "lineTitle",
    lineTitle: "【被共済職員情報】",
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "被共済職員名",
    keyword: "aidedContractorName",
    type: "text",
  },
];

const headTitleList: any[] = [
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export {
  claimHeadTitleList,
  depositHeadTitleList,
  fakeTableList,
  headTitleList,
};
